/**
 * @generated SignedSource<<e867770624ed27ca942ffa6dc55c74ba>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskArticle_viewer$data = {
  readonly zendeskArticles: {
    readonly article?: {
      readonly body: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskArticle_viewer";
};
export type GetHelpZendeskArticle_viewer$key = {
  readonly " $data"?: GetHelpZendeskArticle_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskArticle_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "articleId"
    },
    {
      "kind": "RootArgument",
      "name": "hasArticleId"
    },
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskArticle_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "Contact1stdibsZendeskArticles",
      "kind": "LinkedField",
      "name": "zendeskArticles",
      "plural": false,
      "selections": [
        {
          "condition": "hasArticleId",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "articleId",
                  "variableName": "articleId"
                }
              ],
              "concreteType": "ZendeskArticle",
              "kind": "LinkedField",
              "name": "article",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "body",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5dca801f7386a706316d3054b7fe959a";

export default node;
